<wr-base-dialog
  status="info"
  header="Koordinaten festlegen"
  [submitResponse]="onSubmit.bind(this)"
  [disableSubmit]="disableSubmit"
  [tooltip]="'Bitte Breite (-90 bis 90) und Länge (-180 bis 180) angeben.'"
>
  <hau-form *ngIf="form" [formGroup]="form">
      <hau-form-field
        label="Breitengrad"
        [validation]="form.validation.latitude"
        cols="6"
      >
        <input
          nbInput
          fullWidth
          type="number"
          formControlName="latitude"
          placeholder="z. B. 48.307"
        />
      </hau-form-field>
      <hau-form-field
        label="Längengrad"
        [validation]="form.validation.longitude"
        cols="6"
      >
        <input
          nbInput
          fullWidth
          type="number"
          formControlName="longitude"
          placeholder="z. B. 14.286"
        />
      </hau-form-field>
  </hau-form>
</wr-base-dialog>
